export default __webpack_public_path__ + "static/media/information--minimum-speed-10--g1.3b83bdd9.png";